<template>
  <div class="shopMall">
    <!-- 门店商城介绍  stat -->
    <common-carousel :carouselData="carouselData" />

    <div class="container" style="padding-top: 100px">
      <div class="container-header">
        <img
          class="container-leftTitle"
          :src="`${$baseImgUrl}images/leftTitle.png`"
          alt=""
        />
        <span class="container-title"
          >门店商城 <span class="container-dot"></span>核心功能介绍</span
        >
        <img
          class="container-rightTitle"
          :src="`${$baseImgUrl}images/rightTitle.png`"
          alt=""
        />
      </div>
      <div class="container-content">
        <el-row :gutter="75">
          <el-col
            :span="8"
            v-for="(item, index) in headerList"
            :key="item.key"
            style="margin-bottom: 70px"
          >
            <observer @on-change="upwardOnChange" :threshold="threshold">
              <el-card
                class="business-card flex-display flex-display-column flex-center-align"
                :body-style="{ padding: '0px' }"
                :class="[
                  { 'visible-content': visibleContent },
                  index >= 3 ? ' animation-10 animation-upward' : '',
                ]"
              >
                <div class="flex-display flex-center-pack">
                  <img class="img" :src="item.img" alt="" />
                </div>
                <div style="margin-top: 20px; text-align: center; height: 15px">
                  <div class="title">{{ item.title }}</div>
                  <div class="sub-title">{{ item.subTitle }}</div>
                  <div class="sub-title">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.subTitleTwo }}
                  </div>
                  <div class="sub-title">
                    &nbsp;&nbsp;&nbsp;&nbsp;{{ item.subTitleThree }}
                  </div>
                </div>
              </el-card>
            </observer>
          </el-col>
        </el-row>

        <!-- 门店商城介绍  end -->
      </div>
    </div>

    <div class="shopMall-main">
      <div
        class="main-item"
        :class="{ 'default-theme': item.key % 2 == 1 }"
        v-for="item in mainList"
        :key="item.key"
      >
        <div class="item flex-display">
          <template v-if="item.key % 2 == 1">
            <div class="img-frame">
              <img :src="item.img" alt="" />
            </div>
            <div class="text-frame flex-display flex-center-align">
              <div class="text-content flex-display flex-display-column">
                <span class="title">{{ item.title }}</span>
                <span class="sub-title">{{ item.subTitle }}</span>
              </div>
            </div>
          </template>

          <template v-if="item.key % 2 == 0">
            <div class="text-frame flex-display flex-center-align">
              <div class="text-content flex-display flex-display-column">
                <span class="title">{{ item.title }}</span>
                <span class="sub-title">{{ item.subTitle }}</span>
              </div>
            </div>
            <div class="img-frame"><img :src="item.img" alt="" /></div>
          </template>
        </div>
      </div>
    </div>

    <div class="shopMall-bottom">
      <div class="shopMall-bottom-content">
        <el-row :gutter="55">
          <el-col
            :xs="12"
            :sm="12"
            :lg="{ span: '4-8' }"
            v-for="item in bottomList"
            :key="item.key"
          >
            <observer @on-change="upwardOnChangeTwo" :threshold="threshold">
              <el-card
                class="shopMall-card animation-10 animation-upward"
                :class="{ 'visible-content-two': visibleContentTwo }"
                :body-style="{ padding: '0px' }"
              >
                <div class="circle" :style="{ background: item.background }">
                  <div class="circle-text" :style="{ color: item.color }">
                    {{ item.title }}
                  </div>
                </div>
                <div class="circle-desc">
                  <p class="circle-step" :style="{ color: item.color }">
                    {{ item.step }}
                  </p>
                  <p v-for="i in item.desc" :key="i">{{ i }}</p>
                </div>
                <div class="circle-bottom">......</div>
              </el-card>
            </observer>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="qr-code-footer flex-display flex-right-align">
      <div class="footer-bg-frame flex-display flex-center-pack">
        <img
          :src="`${$baseImgUrl}images/shop-mall-footer-bg.png`"
          class="footer-bg"
          alt=""
        />
        <div class="container flex-display flex-center-pack">
          <div class="left flex-display flex-center-align">
            <span class="text">扫描二维码</span>
            <span class="text">体验更多门店商城功能</span>
          </div>
          <!-- 总部 -->
          <img
            title="点击查看大图"
            :src="`${$baseImgUrlTow}20220107/7ce9e9a2-5138-456f-aa1f-76267d854e26.png`"
            class="qr-code"
            @mouseenter="(centerDialogVisible = true), (viewType = 1)"
            alt=""
          />
          <div class="right flex-display flex-display-column flex-center-pack">
            <span class="title">卡百利总部</span>
            <span class="sub-title">微信小程序</span>
          </div>

          <!-- 大良店 -->
          <img
            title="点击查看大图"
            :src="`${$baseImgUrl}images/daliang-shop-qr-code.png`"
            @mouseenter="(centerDialogVisible = true), (viewType = 2)"
            class="qr-code"
            style="margin-left: 36px"
            alt=""
          />
          <div class="right flex-display flex-display-column flex-center-pack">
            <span class="title">卡百利大良店</span>
            <span class="sub-title">微信小程序</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 卡百利总部 图片放大-弹窗-->
    <el-dialog
      :visible.sync="centerDialogVisible"
      :show-close="false"
      width="30%"
      center
    >
      <span
        slot="title"
        style="font-size: 24px; font-weight: bold; line-height: 45px"
        v-text="viewType === 1 ? '卡百利总部' : '卡百利大良店'"
      >
      </span>
      <div
        slot="footer"
        lass="dialog-footer"
        style="padding: 65px 0; border: 1px solid #e8e8e8"
      >
        <img
          width="300"
          height="300"
          :src="
            viewType === 1
              ? `${$baseImgUrlTow}20220107/7ce9e9a2-5138-456f-aa1f-76267d854e26.png`
              : `${$baseImgUrl}images/daliang-shop-qr-code.png`
          "
          class="qr-code"
          @click="centerDialogVisible = true"
          alt=""
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import commonCarousel from '@/components/common/carousel'
import Observer from '@/components/index.js'

export default {
  components: {
    commonCarousel, Observer
  },
  name: 'shopMall',
  data () {
    return {

      viewType: 1, // 1 卡百利总部  2，大良店
      centerDialogVisible: false,
      threshold: [1], // [0, 0.25, 0.5, 0.75, 1] 1：元素百分百滑动到可见区域时
      visibleContent: false, // 显示-向上的动画效果
      visibleContentTwo: false, // 显示-向上的动画效果
      visibleRight: false, // 显示-右动画效果
      visibleLeft: false, // 显示-左动画效果
      carouselData: [
        {
          title: '门店商城',
          subTitle: '您的专属会员裂变与线上成交工具',
          icon: `${this.$baseImgUrlTow}20220107/65e2e4b7-0ec9-49ac-b63d-41b2d5ea6033.png`,
          rightImg: `${this.$baseImgUrl}images/shopMall-slideshowRight-1.png`,
          url: `${this.$baseImgUrl}images/shopMall-slideshow-1.png`,
          video: `${this.$baseImgUrl}videos/2-shop.mp4`
        }
      ],

      headerList: [
        {
          key: 1,
          title: '好产品好方案好案例',
          img: `${this.$baseImgUrl}images/shopMall-header-1.png`,
          subTitle: '· 500+供应链商品',
          subTitleTwo: '· 1000+优秀设计方案',
          subTitleThree: '· 500,000+客户案例'
        },
        {
          key: 2,
          title: '丰富的营销活动',
          img: `${this.$baseImgUrl}images/shopMall-header-2.png`,
          subTitle: '拼团、砍价、秒杀、满减等丰富营销活动，转化公域流量、激活私域流量、提升GMV（门店业绩）'
        },
        {
          key: 3,
          title: '会员裂变',
          img: `${this.$baseImgUrl}images/shopMall-header-3.png`,
          subTitle: '会员通过分享裂变、团购拼单、邀请有礼活动赚积分换彩电，让客户成为你的超级销售'
        },

        {
          key: 4,
          title: '雷达系统',
          img: `${this.$baseImgUrl}images/shopMall-header-4.png`,
          subTitle: '客户装修股价和预约设计的精准需求，直达数字助手统一管理'
        },

        {
          key: 5,
          title: '本地供应链商品',
          img: `${this.$baseImgUrl}images/shopMall-header-5.png`,
          subTitle: '只需录入到门店商城，帮您一起卖，',
          subTitleTwo: '你的地盘你做主'

        },
        {
          key: 6,
          title: '钱直接到门店',
          img: `${this.$baseImgUrl}images/shopMall-header-6.png`,
          subTitle: '我们不玩虚的，你的都是你的',
          subTitleTwo: '（我的也是你的）'
        }

      ],
      mainList: [{
        key: '1',

        img: `${this.$baseImgUrl}images/shopMall-one.png`,
        title: '线上展示',
        subTitle: '线上展示与分享好产品、好方案、好案例'
      },
      {
        key: '2',
        img: `${this.$baseImgUrl}images/shopMall-two.png`,
        title: '营销活动',
        subTitle: '总部营销活动（团购秒杀预售砍价卡券）直达你的门店商城'

      },
      {
        key: '3',
        img: `${this.$baseImgUrl}images/shopMall-three.png`,
        title: '雷达系统',
        subTitle: '雷达系统精准分析客户画像，客户装修估价和预约设计的精准需求，直达数字助手'

      }],
      bottomList: [
        {
          key: 1,
          title: '引流',
          step: 'STEP.01',
          color: '#4A90E2',
          background: '#f1f7fd',
          desc: ['海量营销素材']
        },
        {
          key: 2,
          title: '进店',
          step: 'STEP.02',
          color: '#266EEC',
          background: '#eef4fe',
          desc: ['装修估价', '预约设计']
        },
        {
          key: 3,
          title: '了解',
          step: 'STEP.03',
          color: '#B460FF',
          background: '#f9f3ff',
          desc: ['店铺主页', '设计师主页', '商品/套餐库', '优秀案例库']
        },
        {
          key: 4,
          title: '成交',
          step: 'STEP.04',
          color: '#F77033',
          background: '#fff4ef',
          desc: ['爆品团购', '在线支付']
        },
        {
          key: 5,
          title: '裂变',
          step: 'STEP.05',
          color: '#FF3240',
          background: '#ffeff0',
          desc: ['会员分享', '活动裂变']
        }
      ]
    }
  },
  methods: {

    goKabelShop () {
      window.open(this.href, '_blank') // 在新窗口打开外链接
    },
    upwardOnChange (entry) {
      // 向上-动画
      console.log(this.visibleContent == true)
      if (!this.visibleContent) {
        this.visibleContent = entry.isIntersecting
      }
    },
    upwardOnChangeTwo (entry) {
      if (!this.visibleContentTwo) {
        this.visibleContentTwo = entry.isIntersecting
      }
    }

  }
}
</script>
<style lang="less" scoped>
.el-col-lg-4-8 {
  width: 20%;
}
.shopMall {
  margin-top: 70px;
}
.container-header {
  text-align: center;
}
.container-title {
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
}
.container-dot {
  width: 6px;
  height: 6px;
  margin: 0 10px;
  display: inline-block;
  background: rgb(38, 110, 236);
  position: relative;
  left: -4px;
  top: -6px;
}
.container-leftTitle {
  padding-right: 20px;
}
.container-rightTitle {
  padding-left: 20px;
}
.container-content {
  padding-top: 60px;
  padding-bottom: 30px;
}
.business-card {
  height: 380px;
  .img-frame {
    width: 100%;
    padding: 35px 0;
  }
  .title {
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 33px;
    margin-bottom: 15px;
  }
  .sub-title {
    width: 250px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin: 0 auto;
  }
}

// 头部END

.shopMall-main {
  .main-item {
    height: 700px;
    background: #fff;
    .item {
      width: 1360px;
      margin: 0 auto;
      .img-frame {
        width: 700px;
        height: 700px;
      }
      .text-frame {
        flex: 1;
        height: 700px;
        padding-left: 100px;
        .title {
          margin-bottom: 40px;
          font-size: 40px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: bold;
          color: #333333;
          line-height: 60px;
        }
        .sub-title {
          width: 380px;
          font-size: 20px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #666666;
          line-height: 40px;
        }
      }
    }
  }
  .default-theme {
    background: #f5f8fe;
  }
}

.shopMall-bottom {
  width: 100%;
  margin-top: 162px;
  height: 566px;
  background: #fff;
  .shopMall-bottom-content {
    width: 1360px;
    margin: 0 auto;
  }
  .shopMall-card {
    position: relative;
    height: 270px;
    text-align: center;
  }
  .circle {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: inline-block;
    margin-top: 25px;
    .circle-text {
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 20px;
    }
  }
  .circle-desc {
    margin-top: 24px;
    .circle-step {
      margin-bottom: 7px;
    }
    p {
      font-size: 14px;
      color: #666666;
    }
  }
  .circle-bottom {
    color: #979797;
    position: absolute;
    bottom: 10px;
    left: 44%;
  }
}

// 动画-上
.animation-upward {
  opacity: 0;
  transform: translateY(50px);
  transform: translateY(50px);
  -ms-transform: translateY(50px);
  -moz-transform: translateY(50px);
  -webkit-transform: translateY(50px);
  -o-transform: translateY(50px);
}

.visible-content.animation-upward {
  transform: translateY(0);
  transform: translateY(0);
  -ms-transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  opacity: 1;
}

// 动画-上-第二个

.visible-content-two.animation-upward {
  transform: translateY(0);
  transform: translateY(0);
  -ms-transform: translateY(0);
  -moz-transform: translateY(0);
  -webkit-transform: translateY(0);
  -o-transform: translateY(0);
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/shopMall.vue